<div class="viewport-container flex h-full gap-4 items-center py-1">
  <!-- Left section: Logo -->
  <div class="flex items-center justify-center gap-4">
    <!-- Logo and text -->
    <a id="brand-logo" class="flex items-center flex-col" routerLink="/">
      <brand-logo class="h-16"></brand-logo>
    </a>
  </div>

  <!-- Right section: Horizontal navigation -->
  <nav class="flex flex-no-wrap ml-auto items-center gap-4">
    <ul class="flex list-style-none gap-12">
      @for(item of menuItems$(); track item) {
      <li class="menu-item" [class.has-submenu]="item.children && item.children.length > 0">
        @if(item.children && item.children.length > 0) {
        <button>
          {{item.text}}
        </button>
        <!-- Flyout menu -->
        <div class="flyout-menu">
          <ul class="flyout-list">
            @for(child of item.children; track child) {
            <li>
              <a [routerLink]="child.link"
                 [fragment]="child.fragment"
                 class="flyout-item"
                 routerLinkActive="active"
                 (click)="removeLeafFocus($event)">
                {{child.text}}
              </a>
            </li>
            }
          </ul>
        </div>
        } @else {
        <a [routerLink]="item.link"
           [fragment]="item.fragment"
           routerLinkActive="active"
           [routerLinkActiveOptions]="{ exact: true }"
           (click)="removeLeafFocus($event)">
          {{item.text}}
        </a>
        }
      </li>
      }
    </ul>
  </nav>

  <div class="social-icons gap-4 items-center ml-4 hidden 5xl:flex">
    <a [href]="contact.social.instagram.link" class="hover:text-pink-500 transition-colors"
       aria-label="Instagram"
       target="_blank">
      <fa-icon [icon]="icons.faInstagram" class="text-2xl text-inherit"></fa-icon>
    </a>
  </div>

  <!-- Sidebar toggle button -->
  <button type="button" class="sidebar-toggle btn-text btn-icon text-xl  
        w-12 h-12
        5xl:hidden 5xl:invisible"
          aria-label="Toggle sidebar"
          mat-ripple (click)="toggleSidebar()">
    <fa-icon [icon]="icons.faBars"></fa-icon>
  </button>
</div>

@if(navigating$()) {
<mat-progress-bar class="!absolute bottom-0 left-0" mode="indeterminate">
</mat-progress-bar>
}